// src/pages/SolicitudesPage.jsx - REEMPLAZA TODO EL CONTENIDO
import React from 'react';
import Layout from '../components/common/Layout';
import SolicitudesPage from "../components/accion/solicitudes";

const SolicitudesPageWrapper = () => {
    return (
        <Layout>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <SolicitudesPage />
            </div>
        </Layout>
    );
};

export default SolicitudesPageWrapper;